module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/03-37680414acc50eae1b687ebde12b0c5d.jpg";